import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

const STORAGE_KEY = 'reporting_exclude_evs';

interface ReportingFiltersContextValue {
    excludeEvs: boolean;
    setExcludeEvs: (value: boolean) => void;
    toggleExcludeEvs: () => void;
}

const ReportingFiltersContext = createContext<ReportingFiltersContextValue | null>(null);

export const ReportingFiltersProvider = ({ children }: { children: ReactNode }) => {
    const [excludeEvs, setExcludeEvsState] = useState(() => {
        localStorage.removeItem(STORAGE_KEY);
        return false;
    });

    const setExcludeEvs = useCallback((value: boolean) => {
        setExcludeEvsState(value);
    }, []);

    const toggleExcludeEvs = useCallback(() => {
        setExcludeEvsState((prev) => !prev);
    }, []);

    return (
        <ReportingFiltersContext.Provider value={{ excludeEvs, setExcludeEvs, toggleExcludeEvs }}>
            {children}
        </ReportingFiltersContext.Provider>
    );
};

export const useReportingFilters = () => {
    const ctx = useContext(ReportingFiltersContext);
    if (!ctx) {
        throw new Error('useReportingFilters must be used within ReportingFiltersProvider');
    }
    return ctx;
};
